<mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
</mat-card-header>
<mat-card-content class="mat-card-style-kc-search-result">
    <div class="table-responsive" matSort style="width:70%;">
        <table mat-table multiTemplateDataRows [dataSource]="dataSourceSearchResultDisplay" matSort #sort="matSort">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="width: 5px;">
                </th>
                <td mat-cell *matCellDef="let row" style="text-align: center;">
                    <mat-checkbox class="check-box" color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? this.selectionSearchResultDisplay.toggle(row) : null; onChangeSelection($event, selectionSearchResultDisplay)"
                        [checked]="selectionSearchResultDisplay.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="tankatableAname">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>単価表名</th>
                <td mat-cell *matCellDef="let e">{{e.tankatableAname}}</td>
            </ng-container>
            <ng-container matColumnDef="applyStartDate">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用開始年月</th>
                <td mat-cell *matCellDef="let e">{{ e.applyStartDate | dateYmStringSg }}</td>
            </ng-container>
            <ng-container matColumnDef="applyEndDate">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用終了年月</th>
                <td mat-cell *matCellDef="let e">{{ e.applyEndDate | dateYmStringSg }}</td>
            </ng-container>
            <ng-container matColumnDef="tankatableExplanation">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>単価表説明</th>
                <td mat-cell *matCellDef="let e">{{e.tankatableExplanation}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
            <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"></tr>
        </table>
        <mat-paginator #paginator [pageSize]="20" showFirstLastButtons id="paginator">
        </mat-paginator>
    </div>
</mat-card-content>